import Logger from 'js-logger'

// eslint-disable-next-line react-hooks/rules-of-hooks
Logger.useDefaults()
const handlers = [Logger.createDefaultHandler()]
Logger.setHandler((...args) => handlers.forEach((handler) => handler(...args)))

let provider = Logger

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const setLoggingProvider = (instance) => (provider = instance)

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const perform = (op, ...args) => {
  if (provider[op] && typeof provider[op] === 'function') {
    return provider[op](...args)
  }
  console.error(`Logging provider does not support operation '${op}'.`, ...args)
  return false
}

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const log = perform.bind(this, 'log')

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const warn = perform.bind(this, 'warn')

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const debug = perform.bind(this, 'debug')

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const info = perform.bind(this, 'info')

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const error = perform.bind(this, 'error')

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
const getLoggerLevel = (level) => provider[level.toUpperCase()]

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const setLevel = (level) => provider.setLevel(getLoggerLevel(level))

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const getLevel = perform.bind(this, 'getLevel')

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export const tap = (handler) => handlers.push(handler)

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
const Logging = {
  log,
  warn,
  debug,
  info,
  error,
  setLoggingProvider,
  setLevel,
  getLevel,
  tap,
  perform,
}

/**
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
export default Logging
